import type { LinkProps } from "@mui/material";
import { Link } from "@mui/material";
import type { FC, PropsWithChildren } from "react";
import { Link as RouterLink } from "react-router-dom";
import { canAccessCustomers } from "../../auth/auth";
import { useAuthContext } from "../../auth/AuthContext";

interface Props {
  readonly customerId: string;
  readonly target?: string;
  readonly color?: LinkProps["color"];
  readonly underline?: LinkProps["underline"];
  readonly variant?: LinkProps["variant"];
}

/** Links to the customer page, or renders plain text when the user has no access to customer pages. */
const CustomerLink: FC<PropsWithChildren<Props>> = ({ customerId, children, ...linkProps }) => {
  const { context } = useAuthContext();
  if (!canAccessCustomers(context)) {
    return <>{children}</>;
  }
  return (
    <Link
      to={`/customers/${customerId}`}
      component={RouterLink}
      onClick={(event) => event.stopPropagation()}
      {...linkProps}
    >
      {children}
    </Link>
  );
};

export default CustomerLink;
